import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {useBestPriceHintSection} from '../useGetProductBulkSection';
import {BestPriceHintSectionView} from './BestPriceHintSectionView';
import {useShouldShowBestPriceGuarantee} from './useShouldShowBestPriceGuarantee';

export const BestPriceHintSection = () => {
  const shouldShowBestPriceGuarantee = useShouldShowBestPriceGuarantee();
  if (!shouldShowBestPriceGuarantee) {
    return null;
  }

  return <BestPriceHintRequest />;
};

const BestPriceHintRequest = () => {
  return (
    <DataFetcher
      request={useBestPriceHintSection()}
      Error={null}
      View={BestPriceHintSectionView}
    />
  );
};
